<template>
  <div class="space-y-4">
    <div v-for="quotation in quotations" :key="quotation.id">
      <div class="bg-white rounded-2xl shadow-md p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-bold text-gray-900">Devis #{{ quotation.id }}</h3>
          <span
            :class="[
              'inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium',
              quotationStatusClass(quotation.approvalStatus),
            ]"
          >
            {{ $t(`claim_quotation.status.${quotation.approvalStatus}`) }}
          </span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
          <StackedField label="Fichier">
            <div class="inline-flex items-center bg-white rounded-sm p-2 border border-gray-200">
              <PaperClipIcon class="shrink-0 h-3 w-3 text-gray-400 mr-1" />
              <span class="text-xs text-gray-900 mr-2 max-w-xs truncate">{{ quotation.fileName }}</span>
              <a
                :href="quotation.url"
                target="_blank"
                rel="noopener noreferrer"
                class="shrink-0 p-1 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-sm transition-colors duration-200"
              >
                <EyeIcon class="h-3 w-3" />
              </a>
            </div>
          </StackedField>
          <StackedField label="Montant" :value="formatPrice(quotation.repairCost)" />
        </div>
        <QuotationCostDetails :quotation="quotation" class="mt-4" />
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { EyeIcon, PaperClipIcon } from "@heroicons/vue/solid";
import QuotationCostDetails from "@/components/claim/details/quotation/QuotationCostDetails.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    quotations: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    StackedField,
    QuotationCostDetails,
    PaperClipIcon,
    EyeIcon,
  },

  computed: {
    ...mapGetters("claimQuotations", ["quotationStatusClass"]),
  },

  methods: {
    formatPrice,
  },
};
</script>
